<template>
    <v-card-component :title="getTitle"
      :icon="parentType === 'mother' ? 'mdi-human-female' : 'mdi-human-male'" @close="handleCloseIcon" :isCloseIcon="showCloseIcon">
      <v-row>
        <v-col cols="12" lg="4" sm="6" v-if="parentType==='father'">
          <span class="body-2 font-weight-medium">
            {{parentLabel}} <span v-if="parentType==='father'"></span> Name <span
              class="error--text" v-if="parentType !=='mother'">*</span></span>
          <v-text-field type="text" placeholder="Name" class="my-0 py-1"
            v-model="value[`${parentType}Name`]"
            :required="formType==='edit_registration' ? true : isRequired"
            :readonly="(formType==='registration') ? true : (formType==='edit_registration' &&  formType === 'admission') ? false : isReadonly"
            :disabled="(formType==='registration') ? true : (formType==='edit_registration' &&  formType === 'admission') ? false : isDisabled"
            single-line> </v-text-field>
        </v-col>
        <v-col cols="12" lg="4" sm="6" v-if="parentType==='mother'">
          <span class="body-2 font-weight-medium">
            {{parentLabel}} <span v-if="parentType==='father'"></span> Name <span
              class="error--text" v-if="parentType ==='mother'">*</span></span>
          <v-text-field type="text" placeholder="Name" v-model="value[`${parentType}Name`]"
            class="my-0 py-1" single-line >
          </v-text-field>
        </v-col>
        <v-col cols="12" lg="4" sm="6" v-if="parentType==='guardian'">
          <span class="body-2 font-weight-medium">
            {{parentLabel}} <span v-if="parentType==='guardian'"></span> Name </span>
          <v-text-field placeholder="Name" v-model="value[`${parentType}Name`]"
            class="my-0 py-1" single-line>
          </v-text-field>
        </v-col>
        <v-col cols="12" lg="4" sm="6" v-if="parentType==='father'">
          <span class="body-2 font-weight-medium">
            {{parentLabel}} <span v-if="parentType==='father'"></span> Mobile No <span
              class="error--text" v-if="parentType !=='mother'">*</span></span>
          <v-text-field placeholder="Mobile No" class="my-0 py-1" single-line type="text"
            v-model="value[`${parentType}Mobile`]" maxlength="10" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            :required="(formType==='edit_registration' || formType==='registration' || formType === 'admission') ? true : isRequired"
            >
          </v-text-field>
        </v-col>
        <v-col cols="12" lg="4" sm="6" v-if="parentType==='mother'">
          <span class="body-2 font-weight-medium">
            {{parentLabel}} <span v-if="parentType==='father'"></span> Mobile No <span
              class="error--text" v-if="parentType ==='mother'">*</span></span>
          <v-text-field placeholder="Mobile No" type="number" class="my-0 py-1" single-line
            v-model="value[`${parentType}Mobile`]" maxlength="10" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);">
          </v-text-field>
        </v-col>
        <v-col cols="12" lg="4" sm="6" v-if="parentType==='guardian'">
          <span class="body-2 font-weight-medium">
            {{parentLabel}} <span v-if="parentType==='guardian'"></span> Mobile No </span>
          <v-text-field placeholder="Mobile No" v-model="value[`${parentType}Mobile`]" type="number"
            class="my-0 py-1" single-line maxlength="10" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);">
          </v-text-field>
        </v-col>
        <v-col cols="12" lg="4" sm="6" v-if="parentType==='father'">
          <span class="body-2 font-weight-medium">
            {{parentLabel}} <span v-if="parentType==='father'"></span> Email <span
              class="error--text" v-if="parentType !=='mother'">*</span></span>
          <v-text-field placeholder="Email" type="email" class="my-0 py-1" single-line
            v-model="value[`${parentType}EmailID`]"
            :required="formType==='edit_registration' ? true : isRequired"
            >
          </v-text-field>
        </v-col>
        <v-col cols="12" lg="4" sm="6" v-if="parentType==='mother'">
          <span class="body-2 font-weight-medium">
            {{parentLabel}} <span v-if="parentType==='father'"></span> Email
            <span class="error--text" v-if="parentType ==='mother'">*</span></span>
          <v-text-field placeholder="Email" v-model="value[`${parentType}EmailID`]" type="email"
            class="my-0 py-1" single-line >
          </v-text-field>
        </v-col>
        <v-col cols="12" lg="4" sm="6" v-if="parentType==='guardian'">
          <span class="body-2 font-weight-medium">
            {{parentLabel}} <span v-if="parentType==='guardian'"></span> Email </span>
          <v-text-field placeholder="Email" v-model="value[`${parentType}EmailID`]" type="email"
            class="my-0 py-1" single-line>
          </v-text-field>
        </v-col>
        <v-col cols="12" lg="4" sm="6" v-if="formType !== 'studEdit' && parentType!=='guardian' ">
          <span class="body-2 font-weight-medium">
            {{parentLabel}} <span v-if="parentType==='father'"></span> Occupation
          </span>
          <v-text-field type="text" placeholder="Occupation"
            v-model="value[`${parentType}Occupation`]" class="my-0 py-1" single-line
            :readonly="isReadonly" :disabled="isDisabled">
          </v-text-field>
        </v-col>
        <v-col cols="12" lg="4" sm="6"
          v-if="(formType == 'edit_registration' || formType==='registration' || formType==='admission') && parentType!=='guardian'">
          <span class="body-2 font-weight-medium">
            {{parentLabel}} <span v-if="parentType==='father'"></span> Designation
          </span>
          <v-text-field type="text" placeholder=" Designation"
            v-model="value[`${parentType}Designation`]" class="my-0 py-1" single-line
            :readonly="isReadonly" :disabled="isDisabled">
          </v-text-field>
        </v-col>
        <v-col cols="12" lg="4" sm="6"
          v-if="(formType == 'edit_registration' || formType==='registration' || formType==='admission' )&& parentType!=='guardian' ">
          <span class="body-2 font-weight-medium">
            {{parentLabel}} <span v-if="parentType==='father'"></span> Qualification
          </span>
          <v-text-field type="text" placeholder="Qualification"
            v-model="value[`${parentType}Qualification`]" class="my-0 py-1" single-line
            :readonly="isReadonly" :disabled="isDisabled">
          </v-text-field>
        </v-col>
      </v-row>
      <v-row
        v-if="(formType == 'edit_registration' || formType==='registration' || formType==='admission') && parentType!=='guardian'">
        <v-col cols="12" lg="4" sm="6">
          <span class="body-2 font-weight-medium">
            {{parentLabel}} <span v-if="parentType==='father'"></span> Organisation
          </span>
          <v-text-field type="text" placeholder="Organisation"
            v-model="value[`${parentType}Organisation`]" class="my-0 py-1" single-line
            :disabled="isDisabled">
          </v-text-field>
        </v-col>
        <v-col cols="12" lg="4" sm="6" v-if="parentType!=='guardian'">
          <span class="body-2 font-weight-medium">
            {{parentLabel}} <span v-if="parentType==='father'"></span> Office Phone No
          </span>
          <v-text-field placeholder="Office Phone No" v-model="value[`${parentType}OfficePhoneNo`]"
            type="number" onKeyPress="if(this.value.length==10) return false;"
            :readonly="isReadonly" :disabled="isDisabled" class="my-0 py-1" single-line>
          </v-text-field>
        </v-col>
        <v-col cols="12" lg="4" sm="6" v-if="parentType!=='guardian'">
          <span class="body-2 font-weight-medium">
            {{parentLabel}} <span v-if="parentType==='father'"></span> Office Address
          </span>
          <v-text-field type="text" placeholder="Office Address"
            v-model="value[`${parentType}OfficeAddress`]"
            :readonly="isReadonly"
            :disabled="isDisabled" class="my-0 py-1" single-line>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="4" sm="6">
        <v-btn v-if="parentType==='mother'" @click="closeFullScreenPopup"><v-icon>mdi-add</v-icon>Add gaurdian</v-btn>
        </v-col >
      </v-row>
      <v-row>

      </v-row>
    </v-card-component>
</template>
<script>
import VCardComponent from '@/components/template/VCardComponent'
export default {
  name: 'RegParentElement',
  components: { VCardComponent },
  data: function () {
    return {
      isReadonly: false,
      isDisabled: false,
      isRequired: false,
      parentLabel: '',
      getTitle: '',
      showGaurdianButton: false,
      showCloseIcon: false
    }
  },
  props: {
    formType: {
      default: '',
      type: String
    },
    parentType: {
      default: '',
      type: String
    },
    pointOfContact: {
      default: '',
      type: String
    },
    value: {
      default: () => {},
      type: Object
    },
    isWritable: {
      default: 'false',
      type: String
    }
  },
  mounted () {
    if (this.isWritable === 'false') {
      this.isReadonly = true
      this.isDisabled = true
    }
  },
  created () {
    if (this.parentType === 'mother') {
      this.parentLabel = 'Mother'
      this.getTitle = "Mother's Details"
      this.showGaurdianButton = true
    } else if (this.parentType === 'father') {
      this.parentLabel = 'Father'
      this.getTitle = "Father's Details"
    } else if (this.parentType === 'guardian') {
      this.parentLabel = 'Gaurdian'
      this.getTitle = 'Gaurdian Details'
      this.showCloseIcon = true
    }
    if (this.isWritable === 'false') {
      this.isReadonly = true
      this.isDisabled = true
    }
    if (this.formType === 'edit_registration' && this.parentType === 'father') {
      this.isRequired = true
    }
  },
  methods: {
    closeFullScreenPopup () {
      this.showGaurdianButton = true
      this.$emit('setIsCompop', this.showGaurdianButton)
    },
    handleCloseIcon () {
      this.showGaurdianButton = false
      this.$emit('closeIcon', this.showGaurdianButton)
    }
  }
}
</script>
